import React from 'react';
import { Check } from 'lucide-react';
import './PlanSelection.css';

interface PlanSelectionProps {
  onComplete: (planId?: string) => void;
  onBack?: () => void;
}

interface Plan {
  id: string;
  name: string;
  price: number | null;
  priceText: string;
  features: string[];
  cta: string;
  highlighted?: boolean;
  priceId?: string;
  isContactUs?: boolean;
}

const PlanSelection: React.FC<PlanSelectionProps> = ({ onComplete, onBack }) => {

  const plans: Plan[] = [
    {
      id: 'free',
      name: 'Free',
      price: 0,
      priceText: '$0/month',
      features: [
        'iMessage access',
        'Scheduling & reminders',
        'Note taking',
      ],
      cta: 'Get Started',
      highlighted: false,
    },
    {
      id: 'standard',
      name: 'Pro',
      price: 20,
      priceText: '$20/month',
      features: [
        'Platform access',
        'LinkedIn integration',
      ],
      cta: 'Try it Free',
      highlighted: true,
      priceId: process.env.REACT_APP_STRIPE_PRICE_STANDARD,
    },
    {
      id: 'enterprise',
      name: 'Enterprise',
      price: null,
      priceText: 'Custom pricing',
      features: [],
      cta: 'Contact us',
      highlighted: false,
      isContactUs: true,
    },
  ];

  const handleSelectPlan = async (planId: string, priceId?: string, isContactUs?: boolean) => {
    // Handle "Contact Us" for Enterprise - open Calendly
    if (isContactUs || planId === 'enterprise') {
      window.open('https://calendly.com/rupa-itsremi/30min', '_blank');
      return;
    }

    // Handle Free plan
    if (planId === 'free') {
      onComplete('free');
      return;
    }

    // Redirect directly to Stripe payment link
    if (planId === 'standard') {
      window.location.href = 'https://buy.stripe.com/eVq00ibFu0RB82Rd5E1Jm00';
      return;
    }
  };

  return (
    <div className="plan-selection-container">
      <div className="plan-selection-content">
        <h2 className="pricing-title">Choose Your Plan</h2>
        <div className="pricing-tiles">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`pricing-tile ${plan.highlighted ? 'highlighted' : ''}`}
            >
              {plan.highlighted && (
                <div className="popular-badge">POPULAR</div>
              )}
              <div className="tile-header">
                <h3 className="tile-name">{plan.name}</h3>
                <div className="tile-price">{plan.priceText}</div>
              </div>
              {plan.features.length > 0 && (
                <ul className="tile-features">
                  {plan.id === 'standard' && (
                    <li className="features-header">Everything in Free, plus:</li>
                  )}
                  {plan.features.map((feature, index) => (
                    <li key={index} className="tile-feature">
                      <Check size={18} className="check-icon" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              )}
              <button
                className={`tile-cta-button ${plan.id === 'standard' ? 'pro-button' : ''} ${plan.id === 'enterprise' ? 'enterprise-button' : ''}`}
                onClick={() => handleSelectPlan(plan.id, plan.priceId, plan.isContactUs)}
              >
                {plan.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlanSelection;
